module.exports = __webpack_public_path__ + "static/media/bg-3.7f16330c.jpg";